var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('student-profile-tab-log-table',{attrs:{"value":_vm.value}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }